// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import { Autocomplete } from "stimulus-autocomplete"
import NestedForm from "stimulus-rails-nested-form"
import ApplicationsController from "./applications_controller"

const application = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))

application.register("autocomplete", Autocomplete)
application.register("nested-form", NestedForm)
application.register("applications", ApplicationsController)
